import React from 'react';
import { TriangleAlertIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
const resources = [{
  id: 'rex',
  Icon: FileTextIcon,
  title: 'Retours d’expérience',
  text: '412 REX analysés cette année par la commission sécurité, publiés sans identification du pilote.',
  link: 'Consulter les REX'
}, {
  id: 'fiches',
  Icon: ShieldCheckIcon,
  title: 'Fiches sécurité par classe',
  text: 'Décollage court, gestion du vent de travers, panne moteur : un mémo par situation et par classe.',
  link: 'Télécharger les fiches'
}];
export function SafetySection() {
  return <section id="securite" className="bg-cloud py-20 lg:py-24" data-id="element-177" data-mp="227eetvc0g1r6">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-178" data-mp="1y4rlfpzoy8rv">
        <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-179" data-mp="1y6cfzfm09rpq">Sécurité des vols</h2>

        <div className="mt-10 grid gap-5 lg:grid-cols-[1.25fr_1fr]" data-id="element-180" data-mp="e70op84vq6v">
          <article className="rounded-xl border-l-4 border-flag bg-white p-6 lg:p-8" data-id="element-181" data-mp="3sju5h85z0yne">
            <p className="flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider text-flag" data-id="element-182" data-mp="1gxplfxkviq13">
              <TriangleAlertIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="1ly3ikkkxsfkc" />
              Vigilance en cours
            </p>
            <h3 className="ffp-display mt-4 text-2xl font-bold text-ink lg:text-[30px]" data-id="element-184" data-mp="17yvi7od1f1ek">
              Tour de France 2026 : restrictions de survol sur les 21 étapes
            </h3>
            <p className="mt-4 text-[15px] leading-relaxed text-ink/70" data-id="element-185" data-mp="1zpruonv6r41b">
              Du 4 au 26 juillet, l’épreuve s’accompagne d’une activité aérienne dense : hélicoptères de
              coordination, prises de vues, transport des organisateurs. Consultez systématiquement les NOTAM et
              SUP AIP avant chaque vol à proximité du parcours.
            </p>
            <div className="mt-6 flex flex-wrap gap-3" data-id="element-186" data-mp="2imt2egg4ji8y">
              <a href="#actualites" className="ffp-focus inline-flex rounded-full bg-navy px-5 py-2.5 text-[14px] font-semibold text-white transition-colors duration-150 ease-soft hover:bg-ink" data-id="element-187" data-mp="2il86oni2pt9i">
                Lire les consignes
              </a>
              <a href="#actualites" className="ffp-focus inline-flex rounded-full border border-line px-5 py-2.5 text-[14px] font-semibold text-navy transition-colors duration-150 ease-soft hover:border-navy" data-id="element-188" data-mp="2t97s0ujgqkv7">
                Voir les zones concernées
              </a>
            </div>
          </article>

          <div className="grid gap-5" data-id="element-189" data-mp="29k767f7vur82">
            {resources.map(resource => <article key={resource.id} className="flex flex-col rounded-xl bg-white p-6" data-id="element-190" data-mp="25ilwg2qnat23">
                <resource.Icon className="h-5 w-5 text-azure" aria-hidden="true" data-id="element-191" data-mp="20k0wm4fb2be6" />
                <h3 className="ffp-display mt-4 text-[19px] font-bold text-ink" data-id="element-192" data-mp="20hxy0w0379xu">{resource.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-ink/65" data-id="element-193" data-mp="1vmiky69wli2h">{resource.text}</p>
                <a href="#demarches" className="ffp-focus mt-auto pt-4 text-[14px] font-semibold text-navy" data-id="element-194" data-mp="1qnxkc5qqowdi">
                  {resource.link}
                </a>
              </article>)}
          </div>
        </div>
      </div>
    </section>;
}